<div #loadingIndicator class="loading-indicator-wrapper" [hidden]="hideLoading">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col text-center align-self-center">
                <div class="loadingAnimation" #loadingAnimation></div>
            </div>
        </div>
    </div>
</div>
